<template>
  <div>
    <v-tooltip v-if="$security.checkUserAccess('CreateTask')" bottom>
      <template v-slot:activator="{ on, attrs }">
        <a-btn
          class="mr-4"
          color="primaryDark"
          dark
          v-bind="attrs"
          v-on="on"
          @click="onCreateTask"
          ><v-icon size="16">mdi-plus</v-icon>{{ $t("task.lblCreateTask") }}
        </a-btn>
      </template>
      <span>{{ $t("task.lblCreateTask") }}</span>
    </v-tooltip>
    <a-dialog
      v-if="showCreateDialog"
      v-model="showCreateDialog"
      scrollable
      max-width="85vw"
      persistent
    >
      <v-card>
        <v-banner color="primaryLight1" dark sticky single-line tile>
          <v-toolbar color="primaryLight1" dark>
            <span> {{ $t("task.lblTask") }} </span>
            <v-spacer></v-spacer>
            <CloseIcon @click="onClose()" />
          </v-toolbar>
        </v-banner>
        <v-card-text id="dialog-card-text" style="height: 600px">
          <v-container style="padding: 12px 0px 0px !important">
            <v-form ref="refTaskForm" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" class="pt-0 pb-0">
                  <a-text-field
                    class="textField"
                    v-model="taskObject.title"
                    :label="$t('task.lblTaskTitle')"
                    :requiredMessage="$t('task.reqTaskTitle')"
                    required
                    dense
                    filled
                  ></a-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div>
                    <span
                      ><strong>{{ $t("agenda.lblDescription") }}</strong></span
                    >
                    <a-rich-text-editor
                      v-if="showTextEditor"
                      v-model="taskObject.description"
                      @descriptionChange="descriptionChanges"
                    ></a-rich-text-editor>
                    <v-skeleton-loader
                      v-else
                      type="list-item-three-line"
                    ></v-skeleton-loader>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6">
                  <span
                    ><strong>{{ $t("task.lblDueDate") }} </strong></span
                  >
                  <v-card flat outlined class="pa-2">
                    <ejs-datetimepicker
                      ref="refDueDate"
                      :locale="locale"
                      :placeholder="waterMark"
                      :value="date"
                      :format="dateFormat"
                      :allowEdit="true"
                      :showClearButton="false"
                      :step="15"
                      :enableMask="true"
                      :strictMode="true"
                      :change="onDateChanged"
                      :min="minimumDate"
                    ></ejs-datetimepicker>
                  </v-card>
                </v-col>
                <v-col
                  class="confidentiality-col"
                  cols="5"
                  sm="4"
                  md="3"
                  lg="3"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <strong v-bind="attrs" v-on="on"
                        >{{ $t("task.confidentiality") }}
                      </strong>
                    </template>
                    <span>{{ $t("task.tipConfidentiality") }}</span>
                  </v-tooltip>
                  <v-switch
                    inset
                    class="confidentiality-switch"
                    v-model="taskObject.is_private"
                  >
                    <template v-slot:prepend>
                      <v-label>{{ $t("task.public") }}</v-label>
                    </template>
                    <template v-slot:append>
                      <v-label>{{ $t("task.private") }}</v-label>
                    </template>
                  </v-switch>
                </v-col>
                <v-col v-if="false" cols="6" sm="6">
                  <span><strong>Status: </strong></span>
                  <v-card flat outlined class="pa-0 pb-3 pl-2">
                    <v-radio-group
                      class="pa-0"
                      dense
                      row
                      v-model="taskObject.status"
                      hide-details
                    >
                      <v-radio
                        v-for="status in statusList"
                        :key="status.value"
                        :label="$t(`task.${status.value}`)"
                        :value="status.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <meeting-participants
                    :meetingAtteendeelist="taskObject.assignees"
                    @onSelection="onAssignChanged"
                    mode="create"
                    :adHocEmail="false"
                    :label="`${$t('task.lblAssignee')}`"
                    :isAlternateEmailShow="false"
                  ></meeting-participants>
                </v-col>
              </v-row>
              <v-row no-gutterss>
                <v-col cols="12">
                  <meetings-list v-model="linkedMeetings"></meetings-list>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-on="on"
                v-bind="attrs"
                color="primaryDark"
                :disabled="!isDirty || isImage"
                @click.stop="onSaveTask"
              >
                {{ $t("btnSave") }}
              </a-btn>
            </template>
            <span> {{ $t("btnSave") }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-on="on"
                v-bind="attrs"
                class="ml-2"
                color="secondary"
                @click="onClose"
              >
                {{ $t("btnClose") }}
              </a-btn>
            </template>
            <span> {{ $t("btnClose") }} </span>
          </v-tooltip>
        </v-card-actions>
        <prevent-confirmation
          :prevent="isPrevent"
          @save="onSaveTask"
          @discard="preventClose(true)"
          @cancel="preventClose(false)"
        >
        </prevent-confirmation>
      </v-card>
    </a-dialog>
  </div>
</template>

<script>
import MeetingParticipants from "../agenda/MeetingParticipants.vue";
import DateTimeRangePicker from "../DateTimeRangePicker.vue";
import { cloneDeep } from "lodash";
import { mapActions, mapGetters } from "vuex";
import MeetingsList from "./MeetingsList.vue";
import PreventConfirmation from "../PreventConfirmation.vue";

export default {
  components: {
    DateTimeRangePicker,
    MeetingParticipants,
    MeetingsList,
    PreventConfirmation,
  },
  name: "CreateTask",
  data() {
    return {
      isImage: false,
      isPrevent: false,
      waterMark: "Select a Due Date",
      showTextEditor: false,
      showCreateDialog: false,
      taskObject: {
        is_private: false,
        id: null,
        title: "",
        description: "",
        dueDate: new Date().toISOString(),
        assignees: [],
        status: "todo",
        linkedMeetings: [],
        createdBy: this.$auth.user.email,
        createdDate: new Date().toISOString(),
        statusHistory: [],
      },
      refTaskObject: {
        is_private: false,
        id: null,
        title: "",
        description: "",
        startDate: new Date().toISOString(),
        dueDate: new Date().toISOString(),
        assignees: [],
        status: "todo",
        linkedMeetings: [],
        createdBy: this.$auth.user.email,
        createdDate: new Date().toISOString(),
        statusHistory: [],
      },
      originalTaskObject: {},
      currentDate: new Date(),
    };
  },
  computed: {
    ...mapGetters({
      statusList: "task/translatedStatusList",
    }),
    LoaderText() {
      return this.$t("SaveLoader");
    },
    linkedMeetings: {
      get() {
        return this.taskObject.linkedMeetings;
      },
      set(value) {
        this.taskObject.linkedMeetings = value;
      },
    },
    locale() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.locale !== "ja" ? "dd-MM-yyyy hh:mm a" : "yyyy-MM-dd HH:mm";
    },
    date() {
      return new Date(this.taskObject.dueDate);
    },
    minimumDate() {
      return this.currentDate;
    },
    isDirty() {
      return (
        JSON.stringify(this.originalTaskObject) !==
        JSON.stringify(this.taskObject)
      );
    },
  },
  mounted,
  beforeDestroy() {
    this.$root.$off("onEditTask");
  },
  methods: {
    ...mapActions({
      createTaskAPI: "task/createTask",
      updateTaskAPI: "task/updateTask",
      getTask: "task/getTask",
    }),
    onCreateTask,
    onClose,
    onAssignChanged,
    onSaveTask,
    onDateChanged,
    onEdit,
    addUpdateTask,
    preventClose,
    descriptionChanges(val) {
      this.isImage = val
    }
  },
};

async function onEdit(id) {
  // this.$emit("loding", true);
  const taskDetails = await this.getTask(id);
  if (!taskDetails.hasOwnProperty("is_private")) {
    taskDetails.is_private = this.taskObject.is_private;
  }
  this.originalTaskObject = cloneDeep(taskDetails);
  this.taskObject = cloneDeep(taskDetails);

  // this.$emit("loding", false);
  this.showCreateDialog = true;
}

function onDateChanged(event) {
  this.taskObject.dueDate = new Date(event.value).toISOString();
}

async function onSaveTask() {
  try {
    this.isPrevent = false;
    if (this.$refs.refTaskForm.validate()) {
      await this.addUpdateTask();
      // this.loaderloading = false;
    }
  } catch (error) {
    this.showCreateDialog = false;
  }
}

async function addUpdateTask() {
  let result;
  if (this.taskObject.id) {
    result = await this.updateTaskAPI(this.taskObject);
  } else {
    const status = {
    email: this.$auth.user.email,
    name: this.$auth.user.tenantUserName,
    updatedDate: new Date().toISOString(),
    status: this.taskObject.status,
  };
  this.taskObject.statusHistory.push(status);
    result = await this.createTaskAPI(this.taskObject);
  }
  if (result.status) {
    const params = {
      message: this.taskObject.id
        ? this.$t("task.lblUpdate")
        : this.$t("task.lblCreated"),
      messageType: "success",
      task: result.data,
    };
    this.$root.$emit("AlertMessage", params);
    this.showCreateDialog = false;
  }
}

function mounted() {
  this.$root.$on("onEditTask", (id) => {
    this.onEdit(id);
  });
  const thisInstance = this;
  setTimeout(() => {
    thisInstance.showTextEditor = true;
  }, 200);
}

function preventClose(status) {
  this.isPrevent = false;
  if (status) {
    this.showCreateDialog = false;
  }
}

function onAssignChanged(assignees) {
  this.taskObject.assignees = assignees.map((item) => ({
    id: item.id,
    email: item.email,
  }));
}

function onCreateTask() {
  let taskObject = cloneDeep(this.refTaskObject);
  taskObject.dueDate = new Date().toISOString();

  this.originalTaskObject = cloneDeep(taskObject);
  this.taskObject = cloneDeep(taskObject);

  this.showCreateDialog = true;
  this.currentDate = new Date();
}

function onClose() {
  if (this.isDirty && this.isImage) {
    this.isPrevent = false;
    this.showCreateDialog = false;
  } else if (this.isDirty) {
    this.isPrevent = true
  } else {
    this.showCreateDialog = false;
  }
}
</script>

<style scoped>
.confidentiality-switch.v-input--selection-controls {
  margin-top: 10px !important;
}
.confidentiality-switch /deep/ .v-input__slot {
  justify-content: center;
}
.confidentiality-switch /deep/ .v-input--selection-controls__input {
  margin-right: 0px;
}
.confidentiality-switch /deep/ .v-input__prepend-outer {
  margin-top: 1px !important;
  white-space: nowrap;
}
.confidentiality-switch /deep/ .v-input__append-outer {
  margin-left: 0 !important;
  margin-top: 1px !important;
  white-space: nowrap;
}
@media (min-width: 1823px) and (max-width: 2048px) {
  .confidentiality-col.col-lg-2 {
    flex: 0 0 16.6666666667%;
    max-width: 11.666667%;
  }
}
@media (min-width: 1264px) and (max-width: 2048px) {
  .confidentiality-col.col-lg-3 {
    flex: 0 0 25%;
    max-width: 20%;
  }
}
@media (min-width: 2049px) and (max-width: 2735px) {
  .confidentiality-col.col-lg-3 {
    flex: 0 0 25%;
    max-width: 14%;
  }
}
@media (min-width: 600px) and (max-width: 1264px) {
  .confidentiality-col.col-sm-4 {
    flex: 0 0 33.3333333333%;
    max-width: 26.333333%;
  }
}
</style>